module.exports = __webpack_public_path__ + "img/online-step-5.43c4c7ce.png";